import script from "./TwoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TwoPage.vue?vue&type=script&setup=true&lang=js"

import "./TwoPage.vue?vue&type=style&index=0&id=d3de032a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3de032a"]])

export default __exports__